const paths = {
  workplanList: '/workplan/list',
  workplanEdit: '/workplan/edit',
  workplanMonitor: '/workplan/monitor',
  workplanReport: '/workplan/report',
  workplanAssignUnit: '/workplan/assignUnit'
  // workplanImport: '/workplan/import'
};

export default paths;
